import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import Fields from './Components/Fields';
import Footer from './Components/Footer';

export default class extends React.PureComponent{

  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    itemDescriptionId: PropTypes.number,
    componentWillMount: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired
  }

  static defaultProps = {
    itemDescriptionId: null
  }

  componentWillMount = () => this.props.componentWillMount(this.props);

  render () {

    const {
      submitting,
      itemDescriptionId,
      onClickCancel
    } = this.props;

    return (
        
      <Modal
        visible  
        title={`${itemDescriptionId ? 'Item Description': 'New Item Description'}`}        
        onCancel={onClickCancel}
        footer={<Footer submitting={submitting} itemDescriptionId={itemDescriptionId} />}
        width={700}
      >
        
        <Fields submitting={submitting} />

      </Modal>
    )
  }
}